import { render, staticRenderFns } from "./r-trigger-wonder.vue?vue&type=template&id=3381fb3d&scoped=true"
import script from "./r-trigger-wonder.vue?vue&type=script&lang=js"
export * from "./r-trigger-wonder.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-wonder.vue?vue&type=style&index=0&id=3381fb3d&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381fb3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3381fb3d')) {
      api.createRecord('3381fb3d', component.options)
    } else {
      api.reload('3381fb3d', component.options)
    }
    module.hot.accept("./r-trigger-wonder.vue?vue&type=template&id=3381fb3d&scoped=true", function () {
      api.rerender('3381fb3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-wonder.vue"
export default component.exports